import React, { useEffect, useState } from 'react';
import DialogCustom from '../../../../dialog/Dialog';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import InputField from '../../../../commom/FormControl/InputField';
import useRoles from '../../../../../hooks/roles/useRoles';

const DialogRole = ({ onClose, show, type, formData }) => {
  const types = ['create', 'edit', 'delete', 'sync'];
  const { errors: errorsData, createRole, updateRole, deleteRole, syncRole } = useRoles();

  const [errors, setInputErrors] = useState({});
  const [form, setInputForm] = useState({ name: '' });
  const [loading, toggleLoading] = useState(false);

  const onSave = async (e) => {
    if (!types.includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false };
      if (type === 'create') {
        result = await createRole(form);
      }
      if (type === 'edit') {
        result = await updateRole(form._id, form);
      }
      if (type === 'delete') {
        result = await deleteRole(form._id);
      }
      if (type === 'sync') {
        result = await syncRole();
      }
      if (result.error) {
        setInputErrors(result);
      } else {
        onClose();
      }
    } finally {
      toggleLoading(false);
    }
  };

  useEffect(() => {
    setInputErrors(errorsData);
  }, [errorsData]);

  useEffect(() => {
    setInputForm(formData);
  }, [formData]);

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={['fal', 'times']}
      >
        Cancel
      </ButtonStartIcon>
      {types.includes(type) && (
        <ButtonStartIcon
          onClick={onSave}
          color='primary'
          variant='contained'
          disabled={loading}
          loading={loading}
          startIcon={['fal', 'check']}
        >
          {['delete', 'sync'].includes(type) ? 'Confirm' : 'Save'}
        </ButtonStartIcon>
      )}
    </>
  );

  const onChange = (e) => {
    const { name, value } = e.target;
    setInputForm({ ...form, [name]: value });
    setInputErrors({ ...errors, [name]: null });
  };

  return (
    <DialogCustom id={`${type}-role`} show={show} title={`${type} role`} onClose={onClose} actions={Actions}>
      {types.includes(type) ? (
        <>
          {['delete', 'sync'].includes(type) ? (
            type === 'sync' ? (
              <Typography>Are you sure you want to sync the roles?</Typography>
            ) : (
              <Typography>
                Are you sure you want to {type} the role: <b>{formData.name}</b>?
              </Typography>
            )
          ) : (
            <div className='flex flex-col gap-4 py-4'>
              <div className='grid grid-cols-3 items-start gap-4'>
                <Typography
                  variant='inherit'
                  className='font-bold'
                  color='primary'
                  align='right'
                  component='p'
                >
                  Name
                </Typography>
                <div className='col-span-2'>
                  <InputField
                    id='name'
                    name='name'
                    value={form.name}
                    error={errors?.name}
                    helperText={errors?.name}
                    onChange={onChange}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <Typography>Invalid type</Typography>
      )}

      {errors && errors.message && (
        <Alert severity='error' onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      )}
    </DialogCustom>
  );
};

export default DialogRole;
